import { Collaborator } from '../interfaces/Collaborator.interface';

export const isCollaboratorDeleted = (collaborator: Collaborator): boolean => {
  return !!collaborator.deletedAt;
};
